import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const CUSTOM_TEXT_SIZES = ['xs-plus', '2xs', '3xs', '4xs', '5xs'];
const CUSTOM_SPACING = [
  'app-header',
  'app-gutter-x',
  'app-gutter-y',
  'app-gutter-top',
  'page-gap',
  'toolbar-gap-offset',
];
const CUSTOM_SHADOWS = [
  'panel',
  'stat-card',
  'button',
  'button-raised',
  'button-raised-hover',
  'button-glow',
  'button-danger-glow',
];
const CUSTOM_BACKGROUND_IMAGES = ['bg-app-glow', 'bg-button-primary', 'bg-table-header'];

const mergeClasses = extendTailwindMerge({
  extend: {
    theme: { text: CUSTOM_TEXT_SIZES, spacing: CUSTOM_SPACING, shadow: CUSTOM_SHADOWS },
    classGroups: { 'bg-image': CUSTOM_BACKGROUND_IMAGES },
  },
});

export function cn(...inputs: ClassValue[]) {
  return mergeClasses(clsx(inputs));
}
